import '.a7{position:fixed;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.g0{bottom:0px;}.ssr-plugin'
import '.hd{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.he{z-index:998;}.ssr-plugin'
import '.hf{transition:opacity 0.3s ease;}.ssr-plugin'
import '.r{height:100vh;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.hg{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hh{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.c0{padding:1.5rem;}.ssr-plugin'
import '.hi{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bv{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a7 co bi bj g0 hd he hf"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a7 co r u ag hg hh a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c v c0 hi bn"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bv at c0"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
